import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "./Banner.css";

const Banner = ({ index }) => {
    const vidRef1 = useRef(null);

    useEffect(() => {
        if (vidRef1.current) {
            vidRef1.current.muted = true;
        }
    }, [index]);

    const renderItem = () => {
        switch (index) {
            case 'home':
                return (
                    <Slider {...sliderSettings}>
                        <div className="slider-image-1"></div>
                        <div className="slider-image-2"></div>

                        <div className="slider-image-3"></div>
                        <div className="slider-image-4"></div>
                        <div className="slider-image-5"></div>
                        <div className="slider-image-6"></div>
                        <div className="slider-image-7"></div>
                        <div className="slider-image-8"></div>
                    </Slider>
                );
                case 'contact':
                    return (
                        <div className="map-contactcontainer">
                            <iframe 
                                className="contact-map"
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d109974.47207000758!2d75.7465079!3d30.5294574!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391067c629ee1a0b%3A0xbbbec4238ce7bd5e!2sDASMESH%20Mechanical%20Works%20Private%20Limited.!5e0!3m2!1sen!2sin!4v1740207142157!5m2!1sen!2sin" 
                                width="100%" 
                                height="600px"
                                style={{ border: "none" }} 
                                title="Contact Page Banner"
                            ></iframe>
                        </div>
                    );
                
            default:
               
        }
    };

    const bannerClass = () => {
        switch (index) {
            case 'home':
                return 'overlay-text';
            default:
                return '';
        }
    };

    const bannerName = () => {
        switch (index) {
            case 'home':
                return 'hmbnnr1';
            case 'about':
                return 'hmbnnr2';
            case 'about-2':
                return 'hmbnnr3';
            case 'about-3':
                return 'hmbnnr4';
            case 'about-4':
                return 'hmbnnr5';
            case 'about-5':
                return 'hmbnnr6';
            case 'about-6':
                return 'hmbnnr7';
            case 'contact':
                return 'iframe'; // Used as a keyword for iframe
            default:
                return 'hmbnnr8';
        }
    };

    // Custom Arrow Components
    const CustomPrevArrow = (props) => {
        const { className, style, onClick } = props;
        return (
            <div
                className={`${className} custom-prev-arrow`}
                style={{ ...style, display: "block" }}
                onClick={onClick}
            >
                ❮
            </div>
        );
    };

    const CustomNextArrow = (props) => {
        const { className, style, onClick } = props;
        return (
            <div
                className={`${className} custom-next-arrow`}
                style={{ ...style, display: "block" }}
                onClick={onClick}
            >
                ❯
            </div>
        );
    };

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
    };

    return (
        <div className={bannerName()}>
            {renderItem()}
            <div className={bannerClass()}></div>
        </div>
    );
};

export default Banner;
